export const NAME = 'licenseesTable';

export enum TABLE_KEYS {
  EMAIL = 'email',
  STATUS = 'status',
  CREATED_AT = 'created_at',
  ACTION = 'action',
}
